import addToHead from '@utils/dom/addToHead';

import registrationConfig from '@cms/core/config/registration/index';
import mastheadConfig from '@cms/core/config/registration/mastheads';

// map masthead code (tealium) to caas masthead name.
export const mapMastheadName = (code) => {
  const masthead = mastheadConfig.get(code);
  if (!masthead) console.error(`Cant get masthead config for ${ code }`, mastheadConfig);
  return masthead.caasId;
};

const getCaasResourceUrl = (config) => {
  const basename = `${ config.site.baseUrl }`.replace(/.+\/\/|www.|\..+/g, '');
  return `${ config.env.caasDomain }${ basename }${ registrationConfig.resourcePaths.caas }`;
};
const getRampartResourceUrl = (config) => `${ config.site.baseUrl }${ registrationConfig.resourcePaths.rampart }`;


// Load Rampart script
export const loadRampart = (config = {}, detail) => new Promise( (resolve, reject) => {
  const id = 'et_rampart_script_inject';
  const el = document.getElementById(id);
  if (el) return console.log('existing rampart script - await event', window.Rampart, el, detail);

  // create script element and handle events.
  const rampartScript = addToHead('script', { src: getRampartResourceUrl(config), id });

  rampartScript.onload = () => {
    // console.log(`editorial tools: loadRampart promise response - fire event `, window.Rampart, detail)
    resolve(rampartScript);
  };
  rampartScript.onerror = () => reject(console.error('editorial tools: error loading rampart script', rampartScript));
});


// Load CaaS script
export const loadCaaS = (config = {}, detail) => new Promise( (resolve, reject) => {
  const id = 'et_CaaS_script_inject';
  const el = document.getElementById(id);

  if (el) return console.log('existing caas script el - await event', window.CaasLite, el, detail);
  // create script element and handle events.
  const caasScript = addToHead('script', { src: getCaasResourceUrl(config), id });
  caasScript.onload = () => {
    // console.log(`editorial tools: loadCaaS promise response - fire event `, window.CaasLite, detail)
    resolve(caasScript);
  };
  caasScript.onerror = () => reject(console.error('editorial tools: error loading CaaS script', caasScript));
});
